import { render } from "./CraftPanel.vue?vue&type=template&id=b7a8213c&scoped=true&ts=true"
import script from "./CraftPanel.vue?vue&type=script&lang=ts"
export * from "./CraftPanel.vue?vue&type=script&lang=ts"

import "./CraftPanel.vue?vue&type=style&index=0&id=b7a8213c&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7a8213c"]])

export default __exports__